// App data for Draunt – combined original + requested additions (images fetched from App Store)
const apps = [
  {
    name: "Calculator",
    category: "Utilities",
    description: "A powerful calculator for basic and scientific.",
    appStoreUrl: "https://apps.apple.com/us/app/calculator/id6746035021",
    icon: "/apps/calculator-icon.webp",
    screenshots: [
      "/apps/calculator-screenshot-1.webp",
      "/apps/calculator-screenshot-2.webp",
      "/apps/calculator-screenshot-3.webp"
    ],
    microcopy: "Solve math problems easily.",
    badge: "Top Rated"
  },
  {
    name: "Fraction Calculator",
    category: "Utilities",
    description: "Easily solve fraction problems and conversions.",
    appStoreUrl: "https://apps.apple.com/us/app/fraction-calculator/id6745460607",
    icon: "/apps/fraction-icon.webp",
    screenshots: [
      "/apps/fraction-screenshot-1.webp",
      "/apps/fraction-screenshot-2.webp",
      "/apps/fraction-screenshot-3.webp"
    ],
    microcopy: "Fraction calculations for everyone."
  },
  {
    name: "World Clock",
    category: "Utilities",
    description: "Keep track of time zones around the world.",
    appStoreUrl: "https://apps.apple.com/us/app/world-clock/id6748332790",
    icon: "/apps/worldclock-icon.webp",
    screenshots: [
      "/apps/worldclock-screenshot-1.webp",
      "/apps/worldclock-screenshot-2.webp",
      "/apps/worldclock-screenshot-3.webp"
    ],
    microcopy: "Track time zones worldwide."
  },
  {
    name: "Calorie Counter",
    category: "Health & Fitness",
    description: "Log macros and calories for a healthier lifestyle.",
    appStoreUrl: "https://apps.apple.com/us/app/macros-calorie-counter/id6737167562",
    icon: "/apps/macros-icon.webp",
    screenshots: [
      "/apps/macros-screenshot-1.webp",
      "/apps/macros-screenshot-2.webp",
      "/apps/macros-screenshot-3.webp"
    ],
    microcopy: "Track your daily macros and calories.",
    badge: "New"
  },
  {
    name: "Interval Timer",
    category: "Health & Fitness",
    description: "Interval timer for exercise and everything else.",
    appStoreUrl: "https://apps.apple.com/us/app/interval-timer/id6746327977",
    icon: "/apps/interval-timer-icon.webp",
    screenshots: [
      "/apps/interval-timer-screenshot-1.webp",
      "/apps/interval-timer-screenshot-2.webp",
      "/apps/interval-timer-screenshot-3.webp",
      "/apps/interval-timer-screenshot-4.webp",
      "/apps/interval-timer-screenshot-5.webp"
    ],
    microcopy: "Time intervals for everything."
  },
  {
    name: "Rain Sounds",
    category: "Health & Fitness",
    description: "Relax and sleep better with rain sounds.",
    appStoreUrl: "https://apps.apple.com/us/app/rain-sounds/id6746427559",
    icon: "/apps/rain-sounds-icon.webp",
    screenshots: [
      "/apps/rain-sounds-screenshot-1.webp",
      "/apps/rain-sounds-screenshot-2.webp",
      "/apps/rain-sounds-screenshot-3.webp",
      "/apps/rain-sounds-screenshot-4.webp"
    ],
    microcopy: "Calm your mind with natural rain sounds."
  },
  {
    name: "Water Tracker",
    category: "Health & Fitness",
    description: "Track your daily water intake.",
    appStoreUrl: "https://apps.apple.com/us/app/water/id6747019078",
    icon: "/apps/water-icon.webp",
    screenshots: [
      "/apps/water-screenshot-1.webp",
      "/apps/water-screenshot-2.webp",
      "/apps/water-screenshot-3.webp",
      "/apps/water-screenshot-4.webp"
    ],
    microcopy: "Stay hydrated with water tracking."
  },
  {
    name: "DMV Practice Test",
    category: "Education",
    description: "Ace your driver's license test with ease.",
    appStoreUrl: "https://apps.apple.com/us/app/dmv-test-practice/id6443748977",
    icon: "/apps/dmv-icon.webp",
    screenshots: [
      "/apps/dmv-screenshot-1.webp",
      "/apps/dmv-screenshot-2.webp",
      "/apps/dmv-screenshot-3.webp",
      "/apps/dmv-screenshot-4.webp"
    ],
    microcopy: "Pass your DMV test with confidence."
  },
  {
    name: "CDL Study",
    category: "Education",
    description: "Prepare for your CDL exams with focused study tools.",
    appStoreUrl: "https://apps.apple.com/us/app/cdl-study/id1644841843",
    icon: "/apps/cdl-icon.webp",
    screenshots: [
      "/apps/cdl-screenshot-1.webp",
      "/apps/cdl-screenshot-2.webp",
      "/apps/cdl-screenshot-3.webp"
    ],
    microcopy: "Study smarter for your CDL test."
  },
  {
    name: "Invoice Generator",
    category: "Utilities",
    description: "Create and share professional invoices in minutes.",
    appStoreUrl: "https://apps.apple.com/us/app/invoice-generator/id6756562276",
    icon: "/apps/invoice-generator-icon.jpg",
    screenshots: [
      "/apps/invoice-generator-screenshot-1.jpg",
      "/apps/invoice-generator-screenshot-2.jpg",
      "/apps/invoice-generator-screenshot-3.jpg"
    ],
    microcopy: "Generate invoices on the go."
  },
  // ---- New apps requested (images fetched from App Store) ----
  {
    name: "Internet Browser",
    category: "Utilities",
    description: "Fast private browser to search, browse tabs and visit sites with privacy.",
    appStoreUrl: "https://apps.apple.com/us/app/internet-browser/id6791052201",
    icon: "/apps/internet-browser-icon.jpg",
    screenshots: [
      "/apps/internet-browser-screenshot-1.jpg",
      "/apps/internet-browser-screenshot-2.jpg",
      "/apps/internet-browser-screenshot-3.jpg"
    ],
    microcopy: "Search and browse with more privacy.",
    badge: "New"
  },
  {
    name: "Analog Clock",
    category: "Utilities",
    description: "Clean customizable analog clock faces for iPhone and iPad.",
    appStoreUrl: "https://apps.apple.com/us/app/analog-clock/id6785887940",
    icon: "/apps/analog-clock-icon.jpg",
    screenshots: [
      "/apps/analog-clock-screenshot-1.jpg",
      "/apps/analog-clock-screenshot-2.jpg",
      "/apps/analog-clock-screenshot-3.jpg"
    ],
    microcopy: "Beautiful analog faces, your style."
  },
  {
    name: "Period Tracker",
    category: "Health & Fitness",
    description: "Understand your cycle, track symptoms and stay prepared every day.",
    appStoreUrl: "https://apps.apple.com/us/app/period-tracker/id6789469574",
    icon: "/apps/period-tracker-icon.jpg",
    screenshots: [
      "/apps/period-tracker-screenshot-1.jpg",
      "/apps/period-tracker-screenshot-2.jpg",
      "/apps/period-tracker-screenshot-3.jpg"
    ],
    microcopy: "Track cycles and stay prepared.",
    badge: "New"
  },
  {
    name: "Construction Calculator",
    category: "Utilities",
    description: "Estimate materials, solve jobsite math and convert measurements fast.",
    appStoreUrl: "https://apps.apple.com/us/app/construction-calculator/id6784237200",
    icon: "/apps/construction-calculator-icon.jpg",
    screenshots: [
      "/apps/construction-calculator-screenshot-1.jpg",
      "/apps/construction-calculator-screenshot-2.jpg",
      "/apps/construction-calculator-screenshot-3.jpg"
    ],
    microcopy: "Jobsite math made simple."
  },
  {
    name: "Work Schedule",
    category: "Productivity",
    description: "Plan shifts, track hours and manage jobs week after week.",
    appStoreUrl: "https://apps.apple.com/us/app/work-schedule/id6780151505",
    icon: "/apps/work-schedule-icon.jpg",
    screenshots: [
      "/apps/work-schedule-screenshot-1.jpg",
      "/apps/work-schedule-screenshot-2.jpg",
      "/apps/work-schedule-screenshot-3.jpg"
    ],
    microcopy: "Shifts, hours and jobs organized."
  },
  {
    name: "To Do List",
    category: "Productivity",
    description: "Organize tasks, manage your day and never miss what matters.",
    appStoreUrl: "https://apps.apple.com/us/app/to-do-list/id6774552301",
    icon: "/apps/to-do-list-icon.jpg",
    screenshots: [
      "/apps/to-do-list-screenshot-1.jpg",
      "/apps/to-do-list-screenshot-2.jpg",
      "/apps/to-do-list-screenshot-3.jpg"
    ],
    microcopy: "Tasks in order, day in control."
  },
  {
    name: "Birthday Reminder",
    category: "Utilities",
    description: "Remember birthdays, celebrate loved ones and never miss a date.",
    appStoreUrl: "https://apps.apple.com/us/app/birthday-reminder/id6769693157",
    icon: "/apps/birthday-reminder-icon.jpg",
    screenshots: [
      "/apps/birthday-reminder-screenshot-1.jpg",
      "/apps/birthday-reminder-screenshot-2.jpg",
      "/apps/birthday-reminder-screenshot-3.jpg"
    ],
    microcopy: "Never miss a birthday again."
  },
  {
    name: "Countdown",
    category: "Utilities",
    description: "Track birthdays, vacations and milestones worth counting down to.",
    appStoreUrl: "https://apps.apple.com/us/app/countdown/id6765612940",
    icon: "/apps/countdown-icon.jpg",
    screenshots: [
      "/apps/countdown-screenshot-1.jpg",
      "/apps/countdown-screenshot-2.jpg",
      "/apps/countdown-screenshot-3.jpg"
    ],
    microcopy: "Count down to what matters."
  },
  {
    name: "Time Zone Converter",
    category: "Utilities",
    description: "Convert time zones, compare world times and plan meetings across cities.",
    appStoreUrl: "https://apps.apple.com/us/app/time-zone-converter/id6762928494",
    icon: "/apps/time-zone-converter-icon.jpg",
    screenshots: [
      "/apps/time-zone-converter-screenshot-1.jpg",
      "/apps/time-zone-converter-screenshot-2.jpg",
      "/apps/time-zone-converter-screenshot-3.jpg"
    ],
    microcopy: "World times, one tap away."
  },
  {
    name: "CNA Practice Exam",
    category: "Education",
    description: "Prepare for the CNA exam with practice questions and study tools.",
    appStoreUrl: "https://apps.apple.com/us/app/cna-practice-exam/id6443749437",
    icon: "/apps/cna-practice-exam-icon.jpg",
    screenshots: [
      "/apps/cna-practice-exam-screenshot-1.jpg",
      "/apps/cna-practice-exam-screenshot-2.jpg",
      "/apps/cna-practice-exam-screenshot-3.jpg"
    ],
    microcopy: "CNA prep you can trust."
  },
  {
    name: "ATI TEAS Practice Test",
    category: "Education",
    description: "Master the ATI TEAS with focused practice tests and review.",
    appStoreUrl: "https://apps.apple.com/us/app/ati-teas-practice-test/id6443749683",
    icon: "/apps/ati-teas-practice-test-icon.jpg",
    screenshots: [
      "/apps/ati-teas-practice-test-screenshot-1.jpg",
      "/apps/ati-teas-practice-test-screenshot-2.jpg",
      "/apps/ati-teas-practice-test-screenshot-3.jpg"
    ],
    microcopy: "Ace your ATI TEAS exam."
  },
  {
    name: "Digital Clock",
    category: "Utilities",
    description: "Stylish digital clock with customizable faces and widgets.",
    appStoreUrl: "https://apps.apple.com/us/app/digital-clock/id6761295502",
    icon: "/apps/digital-clock-icon.jpg",
    screenshots: [
      "/apps/digital-clock-screenshot-1.jpg",
      "/apps/digital-clock-screenshot-2.jpg",
      "/apps/digital-clock-screenshot-3.jpg"
    ],
    microcopy: "Time, beautifully displayed."
  },
  {
    name: "Alarm Clock",
    category: "Utilities",
    description: "Reliable alarm clock with custom sounds and smart wake options.",
    appStoreUrl: "https://apps.apple.com/us/app/alarm-clock/id6760958938",
    icon: "/apps/alarm-clock-icon.jpg",
    screenshots: [
      "/apps/alarm-clock-screenshot-1.jpg",
      "/apps/alarm-clock-screenshot-2.jpg",
      "/apps/alarm-clock-screenshot-3.jpg"
    ],
    microcopy: "Wake up on time, every time."
  },
  {
    name: "Calendar",
    category: "Productivity",
    description: "Simple powerful calendar to plan days, events and reminders.",
    appStoreUrl: "https://apps.apple.com/us/app/calendar/id6758635486",
    icon: "/apps/calendar-icon.jpg",
    screenshots: [
      "/apps/calendar-screenshot-1.jpg",
      "/apps/calendar-screenshot-2.jpg",
      "/apps/calendar-screenshot-3.jpg"
    ],
    microcopy: "Plan every day with ease."
  },
];

export default apps;
